import { styled } from '@mui/material/styles';

export const StyledText = styled('p')(({ theme }) => ({
  fontSize: theme.fontSize.small,
  fontWeight: 400,
  lineHeight: '14px',
  color: theme.palette.text.secondary_txt,
  margin: '0 0 16px 0',
  [`@media screen and (max-height: ${theme.vertical_breakpoints.medium})`]: {
    margin: '0 0 6px 0',
  },
}));

export const StyledPromptText = styled('p')(({ theme }) => ({
  width: '300px',
  textWrap: 'wrap',
  fontSize: theme.fontSize.main,
  fontWeight: 400,
  lineHeight: '18px',
  color: theme.palette.text.full_black_txt,
}));

export const StyledPromptTitle = styled('span')(({ theme }) => ({
  fontSize: `${theme.fontSize.medium}!important`,
  fontWeight: '500!important',
  color: `${theme.palette.text.title_txt}!important`,
}));

export const StyledSecondaryTitle = styled('h3')(({ theme }) => ({
  fontFamily: theme.fonts.robotoMedium,
  fontSize: theme.fontSize.medium,
  fontWeight: '500',
  lineHeight: '21px',
  color: theme.palette.text.title_txt,
  margin: 0,
}));

export const StyledAsterisk = styled('span')(({ theme }) => ({
  color: theme.palette.labels.bt_red_reg,

  '&::after': {
    content: '"*"',
    display: 'inline',
  },
}));

export const MergePromptTitleWrapper = styled('span')(({ theme }) => ({
  fontFamily: theme.fonts.robotoMedium,
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
  whiteSpace: 'nowrap',
}));

export const MergeReasonWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  gap: '10px',
  flex: 1,

  '& > div': {
    marginTop: '0!important',
    width: '100%!important',
  },
}));

export const StyledCheckbox = styled('label')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  justifyContent: 'space-between',
  color: theme.palette.text.txt_default,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',

  '& > input': {
    accentColor: theme.palette.icons.icons_grey_v1,
    margin: '1px 0 0 0',
  },
}));

export const StyledAnnotation = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.grey.bt_alt_grey_light,
  marginLeft: '16px',
  padding: '4px',
  color: theme.palette.text.txt_default,
  fontSize: theme.fontSize.small,
  fontWeight: 400,
  lineHeight: '16px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

export const DontShowMeAgainWrapper = styled('div')(({ theme }) => ({
  padding: '4px',
  color: theme.palette.text.txt_default,
  fontSize: theme.fontSize.small,
  fontWeight: 400,
  lineHeight: '16px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',

  '& > input': {
    accentColor: theme.palette.icons.icons_grey_v1,
    margin: '1px 0 0 0',
  },
}));

export const MergeContentWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: '32px',
  paddingTop: '8px',
}));

export const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '0',
  padding: '16px 0 16px 16px',
  width: '100%',
  [`@media screen and (max-height: ${theme.vertical_breakpoints.medium})`]: {
    padding: '16px 0 8px 16px',
    marginTop: '16px',
  },
}));

export const LeftSideWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '0 0 40%',
}));

export const StyledOptionsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  columnGap: '24px',
  rowGap: '16px',
  [`@media screen and (max-height: ${theme.vertical_breakpoints.medium})`]: {
    rowGap: '8px',
  },
}));

export const MergeStatusWrapper = styled('div')(({ theme }) => ({
  marginTop: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'flex-start',
  [`@media screen and (max-height: ${theme.vertical_breakpoints.medium})`]: {
    marginTop: '6px',
  },
}));

export const MergeStatusValue = styled('div', {
  shouldForwardProp: (prop) => !['isEmpty'].includes(prop),
})(({ theme, isEmpty }) => ({
  width: '224px',
  padding: '4px 8px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  minWidth: '150px',
  fontSize: theme.fontSize.main,
  borderRadius: '4px',
  border: `1px solid ${
    isEmpty ? theme.palette.blueLabels.bt_blue_field_empty_hover : theme?.palette?.grey?.divider_grey_v1
  }`,
  backgroundColor: isEmpty ? theme?.palette?.blueLabels?.bt_blue_field_empty : 'transparent',
  color: isEmpty ? theme?.palette?.blueLabels?.bt_blue_chip_reg : theme.palette.text.txt_default,

  '&:hover': {
    border: `1px solid ${theme?.palette?.blueLabels?.bt_blue_chip_light}`,
    backgroundColor: isEmpty ? theme?.palette?.blueLabels?.bt_blue_field_empty_hover : 'transparent',
  },
}));

export const StyledFieldLabel = styled('span')(({ theme }) => ({
  fontSize: theme.fontSize.small,
  fontWeight: 400,
  lineHeight: '14px',
  color: theme.palette.text.secondary_txt,
  marginLeft: '4px',
}));
